//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import { ProductFeedProtocolType } from '@legacy-components/catalog/product-feed-health/product-feed-health-constants';

(function () {
  angular.module('curalate').filter('formatFeedLocationFromProtocol', [
    '$log',
    function ($log) {
      // Hacky solution for sending 2 pieces of data from the UI to here is using payload
      // `payload` consists of {`protocol`, `location`}, where the protocol is the protocol type of the client's
      // location is where the client's feed lives.
      return function (payload) {
        const protocol = payload.protocol;
        const location = payload.feedLocation;
        switch (protocol) {
          case ProductFeedProtocolType.API:
            return 'Connected via API';
          case ProductFeedProtocolType.FTP:
            return `Connected via FTP: ${location}`;
          case ProductFeedProtocolType.SFTP:
            return `Connected via SFTP: ${location}`;
          case ProductFeedProtocolType.HTTP:
            return `Connected via HTTP: ${location}`;
          case ProductFeedProtocolType.HTTPS:
            return `Connected via HTTPS: ${location}`;
          case ProductFeedProtocolType.S3_SFTP:
            return 'Pushed to Bazaarvoice Vibe via SFTP';
          case ProductFeedProtocolType.S3_STATIC:
            return 'Static file uploaded to Bazaarvoice Vibe';
          case ProductFeedProtocolType.S3_DEPRECATED:
            return 'Your product feed location is deprecated. Please contact support.';
          case ProductFeedProtocolType.S3_BAZAAR_VOICE:
            return 'Pushed to Bazaarvoice Vibe from Bazaarvoice';
          case ProductFeedProtocolType.SHOPIFY:
            return `Connected via Shopify: ${location}`;
          case ProductFeedProtocolType.SHOPIFY2:
            return `Connected via Shopify: ${location}`;
          case ProductFeedProtocolType.MAGENTO:
            return `Connected via Magento: ${location}`;
          case ProductFeedProtocolType.SYNTHETIC_FEEDS:
            return `Your catalog is synthetically generated from Syndication retailers`;
          default:
            $log.error(
              `Product catalog URL contained an unrecognized protocol: ${protocol}.`,
            );
            return undefined;
        }
      };
    },
  ]);
})();
